<ng-container>
  <!--  TODO uncomment when implementing mobile only -->
  <!--  <ng-container *ngIf="isMobileDevice else notMobileDevice">-->

  <!--  <app-navbar></app-navbar>-->
</ng-container>


<!-- completedReviews -->
<div *ngIf="completedReviews.length >= 1">
  <div *ngFor="let review of completedReviews.slice().reverse()" style="display: flex;
  justify-content: center; align-items: center; flex-direction: row; margin-top: 25px;">
    <!-- Old code
        <button class="gabadoo-review-card completed-gabadoo-review-card" (click)="goToCompletedGabadooReview(review)">
    &lt;!&ndash;    <span class="completed-gabadoo-icon">
          <img class="completed-gabadoo-icon-tick" src="../../../../assets/images/header/tick.png" alt="update icon">
        </span>&ndash;&gt;
          <mat-icon  class="card-action-check-icon">check_circle</mat-icon>
          <span class="gabadoo-review-card-name">
          {{ review.childInfo.childName | titlecase }} <br>
        </span>
          <span class="gabadoo-review-card-description">
          {{ review.reviewDetails.createdAt | date :  "dd/MM/y"}} - {{review.reviewDetails.areaOfFocus ? review.reviewDetails.areaOfFocus : 'N/A'}}
        </span>
        </button>
    -->

    <mat-card class="complete-review-card review-card" (click)="goToCompletedGabadooReview(review)"
              [matBadgeHidden]="review.reviewDetails.isCompletedGabaPlanSeen || review.reviewDetails.isQuestionAsked === false"
              matBadge="1" matBadgePosition="after" matBadgeColor="'#28ACAC'">
      <mat-card-content>
        <div style="display: flex; justify-content: center; align-items: center; z-index: 1; flex-direction: column; width: 100%; height: 100%;">
          <h5 class="gabadoo-review-card-name-content">{{ review.childInfo.childName | titlecase }}</h5>
          <div class="review-info">
            <p class="review-date-value">{{ review.reviewDetails.createdAt | date :  "dd/MM/y"}}</p>
            <p class="review-date-value">{{review.reviewDetails.areaOfFocus | titlecase }}</p>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>

<div *ngIf="completedReviews.length === 0" style="display: flex; justify-content: center; align-items: center; flex-direction: row; margin-top: 25px;">
  <button class="gabadoo-review-card completed-gabadoo-review-card" >
    <mat-icon  class="card-action-check-icon" style="font-size: 2rem">check_circle</mat-icon>
    <span class="gabadoo-review-card-name" style="font-size: 17px">
      No Completed Reviews found <br>
    </span>
    <br>
  </button>
</div>


<div  class="gabadooCardContainer">
  <button class="gabadoo-review-card completed-gabadoo-review-card" >
    <mat-icon  class="card-action-check-icon" style="font-size: 2rem">check_circle</mat-icon>
    <span class="gabadoo-review-card-name" style="font-size: 17px">
      Completed Gabadoo will go here <br>
    </span>
    <br>
  </button>
</div>



<!-- not mobile device -->
<!--  TODO uncomment when implementing mobile only -->
<ng-template #notMobileDevice>
  <div class="desktop-container">
    <div class="py-4 text-center header-image">
      <img class="logo-img" src="../../../../assets/images/logo/Logo.png" alt="Gabadoo Logo">
    </div>

    <div class="desktop-text-container">
      <h1 style="text-align: center;">You cannot access this page on a desktop</h1>
      <p>Please re-open on a mobile device</p>
    </div>
  </div>
</ng-template>


